import * as React from 'react';
import {connect} from "react-redux";
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {Auth} from '../../Config/dataModel';
import {URL} from '../../Config/appConfig';

const logo = require('../../resource/img/logo.svg');
const btnSpinner = require('../../resource/img/button-loading.gif');

interface UnsubscriptionConfirmationProps {
    readyToLogout: () => void,
    selectInsurer: () => void,
    auth: () => Auth,
    logout: () => void,
    loginState: () => boolean
}

interface UnsubscriptionConfirmationState {
    loading: boolean
}

class UnsubscriptionConfirmation extends React.Component <RouteComponentProps & UnsubscriptionConfirmationProps, UnsubscriptionConfirmationState> {
    public constructor(props: UnsubscriptionConfirmationProps) {
        super(props);
        this.state = {
            loading: false
        };
        this.goToDashboard = this.goToDashboard.bind(this);
        this.clickLogout = this.clickLogout.bind(this);
    }

    public goToDashboard(event: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        this.props.auth().insurer ? this.props.history.push(URL.DASHBOARD) : this.props.selectInsurer();
    }

    public clickLogout(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({loading: true});
        this.props.readyToLogout();
        this.props.logout();
    }

    public render() {
        return (
            <div className="cmCenter loginContainer">
                <button className="cmHorCenter" onClick={this.goToDashboard}>
                    <img src={logo}/>
                </button>
                <div className="cmText loginLabel authLabel">Unsubscribe confirmation</div>
                <div className="cmText authInfoText">
                    <div>You have been successfully unsubscribed from the list. You will not receive any further emails about daily activity report.</div>
                    <br/>
                    <div>To resubscribe under Account Settings {'>'} Email settings.</div>
                </div>
                <form onSubmit={this.goToDashboard}>
                    <div className="cmBtnsContainer">
                        <div className="cmBtnWrapper">
                            <button className="cmBtn cmGreyBtn cmBoldText" onClick={this.clickLogout}
                                    disabled={this.state.loading}>
                                <span className="cmBtnText">Logout</span>
                                {this.state.loading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                            </button>
                        </div>
                        <div className="cmBtnWrapper">
                            <button type="button" className="cmBtn cmBlueBtn cmBoldText" disabled={this.state.loading} onClick={this.goToDashboard}>Go to Dashboard</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default withRouter(connect(authState, authDispatch)(UnsubscriptionConfirmation));



// WEBPACK FOOTER //
// ./src/Components/Unsubscription/UnsubscriptionConfirmation.tsx